export default {
  data() {
    return {
      isMobile: null,
    };
  },
  created() {
    const mobile = require("is-mobile");

    this.isMobile = mobile({ tablet: true });
  },
};
